export default __webpack_public_path__ + "static/media/VD4.8408e051.png";